import { render, staticRenderFns } from "./Character.vue?vue&type=template&id=3e684d9e&scoped=true&"
import script from "./Character.vue?vue&type=script&lang=js&"
export * from "./Character.vue?vue&type=script&lang=js&"
import style0 from "./Character.vue?vue&type=style&index=0&id=3e684d9e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e684d9e",
  null
  
)

export default component.exports